const FIELD_CONTAINER_SELECTOR = ".hero-banner__form .nf-field-container";
const CALLOUT_ID = "quick-quote-callout";
const CALLOUT_SELECTOR = "#quick-quote-callout";
const CALLOUT_CLOSE_SELECTOR = "#quick-quote-callout-close-icon";

console.log("quick callout mover", FIELD_CONTAINER_SELECTOR, CALLOUT_ID);
const relocateQuickQuoteCallout = () => {
  const target = document.querySelector(FIELD_CONTAINER_SELECTOR);
  const callout = document.getElementById(CALLOUT_ID);

  console.log("found quick callout", target, callout);

  if (!target || !callout || callout.parentElement === target) return false;

  target.appendChild(callout);
  return true;
};

const focusFirstHeroField = () => {
  const heroForm = document.querySelector(".hero-banner__form");
  const firstField =
    heroForm && heroForm.querySelector("input, textarea, select");
  if (firstField) firstField.focus({ preventScroll: true });
};

// Roofle binds its own "open the slide-out calculator" click handler
// directly on the callout node, so a listener added on that same node
// can't reliably out-race it. Intercepting on document during the
// capturing phase always runs before the event reaches the callout,
// letting us swap in "focus the first field" instead of opening the modal.
const interceptCalloutClicks = () => {
  document.addEventListener(
    "click",
    (e) => {
      if (!e.target.closest(CALLOUT_SELECTOR)) return;
      if (e.target.closest(CALLOUT_CLOSE_SELECTOR)) return;

      e.preventDefault();
      e.stopPropagation();
      focusFirstHeroField();
    },
    true,
  );
};

const initQuickQuoteRelocate = () => {
  const outerObserver = new MutationObserver(() => {
    if (document.body.hasAttribute("data-pdm-mini-form")) {
      outerObserver.disconnect();
    }
    interceptCalloutClicks();

    if (relocateQuickQuoteCallout()) return;

    // Roofle's widget script is async and has no ready event, so we wait for
    // it via MutationObserver. Observing documentElement (not just body) in
    // case the widget appends its root container as a sibling of <body>.
    // Stops watching once the callout has actually been relocated.
    const observer = new MutationObserver(() => {
      if (relocateQuickQuoteCallout()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
  outerObserver.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
    attributeFilter: ["data-pdm-mini-form"],
  });
};

export { initQuickQuoteRelocate };
